import { AppButton, AppTextField } from 'components';
import { memo, useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Editor from 'components/CKEditor/Editor';
import { EditorPreviewContext } from 'context/EditorPreviewContext';
import HandleDelete from '../HandleDelete';
import QuizSectionsSettings from './QuizSectionsSettings';
import useQueryParams, { QueryParamsAsString } from 'hooks/useQueryParams';

function ShortAnswer({ editMode, handleSave, data, toggleView, configs = {} }) {
  const history = useHistory();
  const { quizID, courseID, chapterID, classID } = useParams();
  const { PreviewBtn } = useContext(EditorPreviewContext);

  const queryParams = useQueryParams();
  const paperId = queryParams.get('paperId');

  const queryString = QueryParamsAsString();

  const [hint, setHint] = useState('');
  const [explanation, setExplanation] = useState('');

  const [showForm, toggleShowForm] = toggleView ?? [];
  const { hideSaveBtn = false, hideTopBtnSection = false, deleteConfig, showRating } = configs;

  const [section, setSection] = useState(null);
  const [answer, setAnswer] = useState('');
  const [title, setTitle] = useState('');
  const [qStatus, setQStatus] = useState('active');
  const [marks, setMarks] = useState('');

  const [settings, setSettings] = useState({});

  useEffect(() => {
    if (data?.data) {
      setTitle(data?.data?.title || '');
      setQStatus(data?.data?.status || 'active');
      setAnswer(data?.data?.shortAnswer);
      setHint(data?.data?.hint ?? '');
      setExplanation(data?.data?.explanation ?? '');
      setMarks(data?.data?.marks ?? '');
      setSection(data?.data?.sectionId ?? '');

      const __settings = {
        difficultyLevel: data?.data?.difficultyLevel,
        assessmentObjective: data?.data?.assessmentObjective,
        examBoard: data?.data?.examBoard,
        askedInYear: data?.data?.askedInYear,
      };
      setSettings((x) => ({ ...x, ...__settings }));
    }
  }, [data?.data]);

  function handleQuizQuestion(quizFormData = {}) {
    if (!title) {
      window.alert('Please specify the question');
      return;
    }
    if (!answer) {
      window.alert('Please specify an answer');
      return;
    }

    handleSave(quizFormData);
  }

  return (
    <div className="tab__content-actBody">
      <div className="px-5">
        {!hideTopBtnSection && (
          <div className="row justify-content-end my-4 ">
            <div className="col-12">
              {!editMode && (
                <AppButton
                  variantClass="btn-plane p--tint mx-2"
                  onClick={() => {
                    setAnswer([]);
                    setQStatus('active');
                    setTitle('');
                    toggleShowForm(!showForm);
                  }}
                >
                  Change question type
                </AppButton>
              )}
              <AppButton
                variantClass="btn-plane mx-2"
                onClick={() => {
                  history.push(
                    `/classes/${classID}/courses/${courseID}/chapters/${chapterID}/quizzes/${quizID}/questions${queryString}`
                  );
                }}
              >
                Back to questions list
              </AppButton>
            </div>
          </div>
        )}

        <div className="row mt-4">
          <div className="col-md-12 col-lg-12 col-sm-12">
            <div className="lessonWrap lessonWrap--border topalign __short__answer">
              <div className="my-4">
                <div className="w-100 p-3">
                  <QuizSectionsSettings
                    prefix={'saQs' + data?.data?._id}
                    selectedItemId={section}
                    selectedPaperId={paperId}
                    handleChange={(id) => setSection(id)}
                    extras={{
                      settings,
                      setSettings: (item = {}) => setSettings((x) => ({ ...x, ...item })),
                    }}
                  />
                </div>
              </div>
              <div className="w-100 p-3">
                <label htmlFor="questionToFill">Question</label>
                {title && <PreviewBtn block={{ value: title }} />}
                <Editor
                  data={{
                    value: title,
                    onChange: (data) => setTitle(data),
                  }}
                  config={{
                    placeholder: 'Enter the question here',
                  }}
                />
              </div>
              <div className="w-100 p-3">
                <label htmlFor="questionToFill">Answer</label>
                {answer && <PreviewBtn block={{ value: answer }} />}
                <Editor
                  data={{
                    value: answer,
                    onChange: (data) => setAnswer(data),
                  }}
                  config={{
                    placeholder: 'Enter the short answer here',
                  }}
                />
              </div>

              <div className="w-100 p-3">
                <label htmlFor="">Hint</label>
                {hint && <PreviewBtn block={{ value: hint }} />}
                <Editor
                  data={{
                    value: hint,
                    onChange: (data) => setHint(data),
                  }}
                />
              </div>
              <div className="w-100 p-3">
                <label htmlFor="">Explanation</label>
                {explanation && <PreviewBtn block={{ value: explanation }} />}
                <Editor
                  data={{
                    value: explanation,
                    onChange: (data) => setExplanation(data),
                  }}
                />
              </div>

              <div className="w-100 p-3">
                <AppTextField
                  labelProps={{ label: 'Marks' }}
                  inputProps={{
                    placeholder: 'Please provide the maximum marks allocated',
                    value: marks || '',
                    onChange: (event) => setMarks(event.target.value),
                  }}
                />
              </div>

              {/* {!hideSaveBtn && ( */}
              {!showRating && (
                <div className="mb-5 btnTab-foot mt-5">
                  <AppButton
                    className={`btn-right-content ${!hideSaveBtn ? 'save' : 'btn-plane'}`}
                    onClick={() => {
                      handleQuizQuestion({
                        title,
                        shortAnswer: answer,
                        status: qStatus,
                        questionType: 'short',
                        hint,
                        explanation,
                        section,
                        marks,
                        ...settings,
                      });
                    }}
                  >
                    {!hideSaveBtn ? 'Save Changes' : 'Save'}
                  </AppButton>
                  {/* {deleteConfig?.showBtn && (
                    <HandleDelete handleDelete={deleteConfig?.handleDelete} />
                  )} */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(ShortAnswer);
